import React, { useState, useEffect } from "react";
import pdfIcon from "../../assets/images/pdf_icon.png";
import wordIcon from "../../assets/images/word_icon.png";
import PreviewFileModal from "../../components/common/Filemanager_PreviewFileModal";
import { useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const ListCard = ({ title, files, dataLoading }) => {
  const navigate = useNavigate();

  const getIcon = (filetype) => {
    switch (filetype) {
      case "pdf":
        return pdfIcon;
      case "word":
        return wordIcon;
      default:
        return pdfIcon;
    }
  };

  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(false);
  const [selectedFileUrl, setSelectedFileUrl] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [showPreviewModal, setShowPreviewModal] = useState(false);

  const handleClose = () => setShow(false);


  const handleFilePreview = (file) => {
    setSelectedFile(file);
    setShowPreviewModal(true);
  };

  const handleSeeAllFiles = () => {
    navigate("/documents");
  };



  return (
    <div className="dashboard__card list-card">
      <div className="list-card__header d-flex justify-content-between align-content-center">
        <h3 className="list-card__title">{title}</h3>
        <button
          className="btn btn-sm btn-link mb-2"
          onClick={handleSeeAllFiles}
        >
          See All Files
        </button>
      </div>

      <ul className="list-card__list">
        {dataLoading
          ? Array.from({ length: 10 }).map((_, i) => (
            <li
              key={i}
              className="list-card__item"
              style={{ maxHeight: "75px" }}
            >
              <div>
                <Skeleton
                  width={"100%"}
                  height={15}
                  style={{ marginBottom: "1px" }}
                />
                <Skeleton width={"20%"} height={15} />
              </div>
            </li>
          ))
          : files.map((item, index) => (
            <li
              key={index}
              className={`list-card__item ${item.icon && `has-icon`}`}
            >
              <div>
                <div
                  className="list-card__description"

                >
                  {item.file_type && (
                    <span className="icon">
                      <img
                        src={getIcon(item.file_type)}
                        className="icon me-2"
                        alt="icon"
                      />
                    </span>
                  )}
                  <span
                    title={item.file_name}
                    onClick={() => handleFilePreview(item)}
                    style={{
                      maxWidth: "250px",
                      display: "inline-block",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      cursor: "pointer"
                    }}
                  >
                    {item.file_name}
                  </span>
                </div>
                {/* <span className="list-card__timestamp">
                  {item.uploaded_on}
                </span> */}
              </div>
            </li>
          ))}
      </ul>

      <PreviewFileModal
        show={showPreviewModal}
        handleClose={() => setShowPreviewModal(false)}
        file={selectedFile}
      />
    </div>
  );
};

export default ListCard;
